import { render, staticRenderFns } from "./ViewBienBan.vue?vue&type=template&id=0724dbc5&scoped=true"
import script from "./ViewBienBan.vue?vue&type=script&lang=js"
export * from "./ViewBienBan.vue?vue&type=script&lang=js"
import style0 from "./ViewBienBan.vue?vue&type=style&index=0&id=0724dbc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0724dbc5",
  null
  
)

export default component.exports